<div class="evc remeasurement-main-content" id="remeasurement-main-content">
  <div class="canvas-area">
    <div class="canvas-zoom" [ngClass]="{ 'main-canvas-zoomed': imageMagnification > 1 }">
      <div class="status-area" *ngIf="!isReadyMeasurement">{{ "imageRemeasurementEdit.notReadyMessage" | translate }}</div>

      <div fxLayout="row" class="canvas-area-div" id="canvas-area-div" [ngClass]="{ zoomed: imageMagnification > 1 }">
        <div class="dummy-canvas-area" id="dummy-canvas-area">
          <canvas #Canvas class="dummy-canvas" id="dummyCanvas"></canvas>
        </div>
        <div
          class="left-canvas-area"
          id="left-canvas-area"
          (scroll)="syncScrollbarL()"
          (mousemove)="moveCanvas($event)"
        >
          <canvas #Canvas class="left-canvas" id="leftCanvas"></canvas>
        </div>
        <div class="right-canvas-area" id="right-canvas-area" (scroll)="syncScrollbarR()">
          <canvas #Canvas class="right-canvas" id="rightCanvas"></canvas>
        </div>
        <div class="three-d-canvas-area" id="3d-canvas-area" *ngIf="display3DModeObject()">
          <canvas #3dCanvas class="child viz-3d" id="3dCanvas"></canvas>
        </div>
      </div>
    </div>
    <div class="dock">
      <div class="resetCamera-area" *ngIf="display3DModeObject() && is3DMode">
        <button class="reset-view-button" mat-button (click)="resetCameraPosition()">
          <mat-icon class="reset-view-icon" [matTooltip]="'imageRemeasurementEdit.resetView' | translate">restart_alt</mat-icon>
        </button>
      </div>
      <div class="displayMode-area" *ngIf="display3DModeObject()" [style.top]="getDspModeTop()">
        <svg class="image-edit-svg displayMode-icon" viewBox="0 0 24 24">
          <use
            class="color-bg-text"
            [class.border-solid-style]="is3DMode"
            xlink:href="assets/images/brian/buttonicon_meas_measure3D_csr.svg#svg_icon_element_01"
          ></use>
          <use class="none" xlink:href="assets/images/brian/buttonicon_meas_measure3D_csr.svg#svg_icon_background"></use>
        </svg>
        <mat-slide-toggle color="primary" (change)="toggle3DView()" [matTooltip]="'imageRemeasurementEdit.threeDView' | translate">
        </mat-slide-toggle>
      </div>
    </div>
    <div class="slider-area" id="slider-area">
      <app-zoom-slider [min]="1" [max]="4" [value]="imageMagnification" (zoom)="changeImageMagnification($event)"> </app-zoom-slider>
    </div>
  </div>

  <div class="right-area" id="right-area" fxLayout="column">
    <div class="mode-area" id="mode-area">
      <div class="mode-title">
        <label class="title">{{ "imageRemeasurementEdit.mode" | translate }}</label>
      </div>
      <div class="select-mode-div">
        <mat-form-field class="select-mode" appearance="fill">
          <mat-select name="mode" (ngModelChange)="changeMode($event)" [(ngModel)]="selectMode" [disabled]="!isReadyMeasurement || !isEditable">
            <mat-option class="select-item" [value]="mode" *ngFor="let mode of measurementModes">
              {{ getDspMode(mode) }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="result-area" id="result-area">
      <app-measurement-results
        [selectResult]="selectResult"
        [measurementResults]="measurementResult"
        [selectedMeasurementSystem]="unitSelected"
        [isAddPoints]="isAddPoints()"
        [isEdit]="isEditable"
        (removeObject)="removeObject($event)"
        (changeUnit)="changeUnit()"
      />
    </div>
    <div
      class="load-measurement"
      *ngIf="!this.inspectionImage.hasMeasurementImage && !loadMeasurementPressed && plotPointList.length === 0 && measurementResult.length === 0"
    >
      <evc-nav-button [type]="buttonTypes.tertiary" (click)="loadMeasurement()">
        <mat-icon>straighten</mat-icon>
        {{ "imageRemeasurementEdit.loadMeasurement" | translate }}
      </evc-nav-button>
    </div>
  </div>
</div>
